var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"essai",attrs:{"id":"app"}},[_c('Popup'),_c('div',{staticClass:"sm:block hidden",class:`${_vm.background_class}`,style:(`background-image:url(${_vm.background_link})`)}),_c('HeaderElem'),_c('router-view'),_c('FooterElem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }